import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ComplianceRule.css';

class RestrictedRuleGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.restrictedRuleGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        // minWidth: 30
      },
      rowSelection: "multiple",
    };
  }

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var restrictedRuleList = rowNodeArray.map(rowNode => rowNode.data);

    this.props.selectRestrictedRules(restrictedRuleList);
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      filterRestrictedRuleArray,
      className = 'grid-wrapper',
      loadRestrictedSecuritiesActionStatus,
    } = this.props;

    const isLoading = loadRestrictedSecuritiesActionStatus === ACTION_STATUS.LOGINING;
    if (loadRestrictedSecuritiesActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadRestrictedSecuritiesActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={filterRestrictedRuleArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default RestrictedRuleGrid;